module.exports = __webpack_public_path__ + "img/havvind.0c3ea10e.jpg";